import React from 'react';
import styles from './CartItem.module.scss';
import { studentFullName } from '../../../../utils/functions';
import Extras from './Extras';
import Footer from './Footer';

export default function YearbookItem({ orderPackage, removeItem, editable, waivesRetouching }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.headerWrapper}>
        <div className={styles.bigTitle}>{orderPackage.package.name}</div>
      </div>
      <div className={styles.optionTitle}>{studentFullName(orderPackage.student)}</div>
      <Extras orderPackage={orderPackage} removeItem={removeItem} editable={editable} waivesRetouching={waivesRetouching} />
      <Footer orderPackage={orderPackage} removeItem={removeItem} editable={editable} />
    </div>
  );
}
